<template>
  <div>

    <el-form style="display: flex;flex-wrap: wrap;">

      <el-form-item label="时间筛选:" style="display: flex;width: 30%;" >
         <el-select v-model="timeMode" clearable filterable placeholder="请选择时间模式" @change="handleTimeMode">
           <el-option v-for="item in optionstimeModeList" :key="item.id" :label="item.name"  :value="item.id"></el-option>
         </el-select>
      </el-form-item>


      <el-form-item label="计算方式:" style="display: flex;width: 30%;" >
         <el-select v-model="calculationMethod" clearable filterable placeholder="请选择时间模式" @change="handleTimecalculationMethod">
           <el-option v-for="item in optionstimecalculationMethodList" :key="item.id" :label="item.name"  :value="item.id"></el-option>
         </el-select>
      </el-form-item>


      <el-form-item label="计算类型:" style="display: flex;width: 30%;" >
         <el-select v-model="calculationType" clearable filterable placeholder="请选择时间模式" @change="handleCalculationType">
           <el-option v-for="item in optionstimecalculationTypeList" :key="item.id" :label="item.name"  :value="item.id"></el-option>
         </el-select>
      </el-form-item>



      <el-form-item style="display: flex;width: 100%;padding-left: 70px;"  v-show="timeMode === 1">
        <el-date-picker  v-model="value1"  type="week" format="yyyy 第 WW 周"  placeholder="选择周" @change="onWeekChange"></el-date-picker>
      </el-form-item>

      <el-form-item style="display: flex;width: 100%;padding-left: 70px;"  v-show="timeMode === 2">
        <el-date-picker  v-model="value2"  type="month" format="yyyy-MM"  placeholder="选择月" @change="onMonthChange"></el-date-picker>
      </el-form-item>

      <el-form-item style="display: flex;width: 100%;padding-left: 70px;"  v-show="timeMode === 3">
        <el-date-picker  v-model="value3"  type="year" format="yyyy"  placeholder="选择年" @change="onYearChange"></el-date-picker>
      </el-form-item>

      <el-form-item style="display: flex;width: 100%;padding-left: 70px;"  v-show="timeMode === 4">
        <el-date-picker  style="width: 100%;"  v-model="dateTime" type="daterange"  value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期"
          @change="handleDateChange" end-placeholder="结束日期"   clearable  :picker-options="setDateRange">
        </el-date-picker>
      </el-form-item>
      


    </el-form>
    <div style=" text-align: end; padding: 10px;">
      <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
      <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
      <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
    </div>


    <div style="margin-top: 15px;">

      <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: 10px;" v-for="(item,index) in dateList" :key="index" class="chart-item">

        <el-card style="width: 35%; border-radius: 15px;">
          <div ref="charts" :id="`chart-${index}`" style="width: 100%; height: 200px;"></div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">线下</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`offline-pie-${index}`" style="width: 100%; height: 200px; margin-top: 10px;"></div>
            </div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">规划</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`plan-pie-${index}`" style="width: 100%; height: 200px; margin-top: 10px;"></div>
            </div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">纯补课</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`makeup-pie-${index}`" style="width: 100%; height: 200px; margin-top: 10px;"></div>
            </div>
        </el-card>

      </div>

    </div>

    <el-dialog width="80%" :visible.sync="showPopUpNotification" :before-close="showPopUpNotificationCler" :close-on-click-modal="false" modal-append-to-body :append-to-body="true">
        <fistClassComponents v-if="showPopUpNotification"   :paramsComponents="params_ZUJIAN"></fistClassComponents>
    </el-dialog>

  </div>
</template>



<script>
import * as echarts from 'echarts';
import loadingUtils from "../utils/loading";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import fistClassComponents from './fistClass.vue';

export default {
  props:{
    translate: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: '未知'
    },
  },
  components: {
    fistClassComponents,
  },
  data() {
    return {

        showPopUpNotification: false,

        calculationMethod: 2,
        optionstimecalculationMethodList:[
          { id: 1, name: '周环比' },
          { id: 2, name: '月环比' },
          { id: 3, name: '月同比' },
        ],

        calculationType: 1,
        optionstimecalculationTypeList:[
          { id: 1, name: '差异率' },
          { id: 2, name: '差值' },
        ],  

        timeMode: 4,
        optionstimeModeList:[
          { id: 1, name: '自然周' },
          { id: 2, name: '自然月' },
          { id: 3, name: '自然年' },
          { id: 4, name: '自定义' },
        ],
         
        dateList:[ 
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 0, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 0, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 0, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 0, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 1, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
          { isClass: 0, aa: 13.11, bb: 19.1, cc: 33.11, dd: 55.1, },
        ],



        value1:'',
        value2:'',
        value3:'',
        dateTime:[],
        


        option: null,



        setDateRange: {
          disabledDate : (time) =>{
            const today = new Date();
            today.setHours(0, 0, 0, 0); 
            today.setMinutes(0);
            today.setSeconds(0); 
            today.setMilliseconds(0); 
            return time.getTime() > today.getTime();
          }
        },  


        chartData:[],



        selectedYear: '',
        selectedWeekNumber: '',

        selectedYears:  '',
        selectedMonthFormatted: '',

        selectyear: '',

        params_ZUJIAN: null,

    }
  },

  computed: {
   
  },

  mounted() {

    this.dateTime = this.getDefaultDateRange()
    this.handleGetDateList()
    // this.initCharts()
  },

  methods: {

    showPopUpNotificationCler() {
      this.params_ZUJIAN = null;
      this.showPopUpNotification = false;
    },

    onYearChange(value) {
      if (value) {
        const date = new Date(value);
        const year = date.getFullYear();
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        this.selectyear = localDate.getFullYear();
      } else {
        this.selectyear = '';
      }
    },

    onMonthChange(value) {
      if (value) {
        this.extractYearAndMonth(value);
      } else {
        this.selectedYears = '';
        this.selectedMonthFormatted = '';
      }
    },
    extractYearAndMonth(date) {
       //   const year = date.getUTCFullYear();
       //   const month = date.getUTCMonth() + 2; // getUTCMonth 返回 0-11，所以需要加 1

    
      const year = date.getFullYear();
      const month = date.getMonth() + 1; 

      // 格式化月份为两位数
      const monthFormatted = month < 10 ? `0${month}` : `${month}`;

      // 更新数据
      this.selectedYears = year;
      this.selectedMonthFormatted = monthFormatted;
      
    },

    onWeekChange(value) {
      if (value) {
        const { year, week } = this.getYearAndWeek(value);
        this.selectedYear = year;
        this.selectedWeekNumber = week;
      } else {
        this.selectedYear = '';
        this.selectedWeekNumber = '';
      }
    },

    getYearAndWeek(date) {
      // 设置到该周的星期四，以确保正确计算ISO周数
      const targetDate = new Date(date.getTime());
      targetDate.setDate(date.getDate() + (4 - ((date.getDay() + 6) % 7))); // 调整到周四

      const startOfYear = new Date(targetDate.getFullYear(), 0, 1);
      const dayOfWeek = (startOfYear.getDay() + 6) % 7; // 星期一为第一天
      let weekNumber = Math.ceil((((targetDate - startOfYear) / (24 * 60 * 60 * 1000)) + dayOfWeek) / 7);

      // 如果目标日期的1月4日在下一年，则调整年份和周数
      if (targetDate.getFullYear() > startOfYear.getFullYear()) {
        weekNumber = 1;
      }

      return {
        year: targetDate.getFullYear(),
        week: weekNumber < 10 ? '0' + weekNumber : weekNumber // 确保两位数格式
      };
    },

    handleTimecalculationMethod(){
      this.dateTime = []
    },

    handleDateChange(value) {

      if (this.calculationMethod === 1) {
        this.handleWeekRange(value);
      } else if ([2, 3].includes(this.calculationMethod)) {
        this.handleMonthRange(value);
      }else{
        this.$message.warning('请选择计算方式');
        this.dateTime = [];
      }

    },

    getFirstAndLastDayOfMonth(year, month) {
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);
      return { firstDay, lastDay }
    },


    handleMonthRange(value) {

      if (!value || value.length !== 2) {
        this.dateTime = [];
        this.$message.warning('请选择一个完整的月份');
        return;
      }

      const startDate = new Date(value[0]);
      const endDate = new Date(value[1]);


      const startYear = startDate.getFullYear();
      const startMonth = startDate.getMonth() + 1;

      const endYear = endDate.getFullYear();
      const endMonth = endDate.getMonth() + 1;


      const { firstDay: startFirstDay, lastDay: startLastDay  } = this.getFirstAndLastDayOfMonth(startYear, startMonth)
      const { firstDay: endFirstDay, lastDay: endLastDay } = this.getFirstAndLastDayOfMonth(endYear, endMonth)

      startFirstDay.setHours(0, 0, 0, 0);
      startLastDay.setHours(0, 0, 0, 0);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);


      if (startDate.getTime() !== startFirstDay.getTime()) {
          this.dateTime = [];
          this.$message.warning(`开始日期应为 月的第一天为开始日期`);
          return;
      }

      if (endDate.getTime() !== endLastDay.getTime()) {
          this.dateTime = [];
          this.$message.warning(`结束日期应为 月的最后一天为结束日期`);
          return;
      }

    },


    handleWeekRange(value) {

      if (!value || value.length !== 2) {
        this.dateTime = [];
        this.$message.warning('请选择一个完整的周');
        return;
      }
      const startDate = new Date(value[0]);
      const endDate = new Date(value[1]);

      const startDayOfWeek = startDate.getDay();
      const endDayOfWeek = endDate.getDay();

      if (startDayOfWeek !== 1 || endDayOfWeek !== 0) {
        this.dateTime = [];
        this.$message.warning('请选择周一作为开始日期 , 周日作为结束日期');
      }
    },


    handleCalculationType(){
      // 差异率
      if(this.calculationType === 1){
        console.log('差异率')
      }
      // 差值
      if(this.calculationType === 2){
        console.log('差值')
      }
    },

    handleTimeMode(){
      if(this.timeMode === 1){
          this.value2 = ''
          this.value3 = ''
          this.dateTime = []
      }
      if(this.timeMode === 2){
          this.value1 = ''
          this.value3 = ''
          this.dateTime = []
      }
      if(this.timeMode === 3){
          this.value1 = ''
          this.value2 = ''
          this.dateTime = []
      }
      if(this.timeMode === 4){
          this.value1 = ''
          this.value2 = ''
          this.value3 = ''
      }
    },

    handleSearch() {

      if(!this.timeMode){
          this.$message.warning('请选择时间筛选~')
          return
      }
      this.handleGetDateList()

    },

    handleClear() {
      this.timeMode = 4
      this.calculationMethod = 2
      this.calculationType = 1
      this.value1 = ''
      this.value2 = ''
      this.value3 = ''

      this.dateTime = this.getDefaultDateRange()
      this.handleGetDateList()

    },

    initCharts() {


      loadingUtils.startLoading();
      const charts = document.querySelectorAll('.chart-item  div[id^="chart-"]')


      this.$nextTick(()=>{
        charts.forEach((chart, index) => {

            if (!this.dateList[index]) return;

            let chartInstance = echarts.init(chart)
            let option = this.getChartOption(index)
            option && chartInstance.setOption(option)


            // 线下饼图
            let offlinePie = echarts.init(document.getElementById(`offline-pie-${index}`));
            offlinePie.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                      return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                    }
                },

                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: 0,
                    data: ['已成功', '未成功', '未知'],
                    left: 'left',
                    icon: 'circle', // 让图例变成圆点
                    selectedMode: false 
                },
                series: [{
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '60%'],
                    data: [
                        { 
                          percent: this.dateList[index] && this.dateList[index].offlineSuccessNum ? this.dateList[index].offlineSuccessNum : 0, 
                          isCopyNane: 2,
                          value: this.chartData[index] && this.chartData[index].offlineYes ? this.chartData[index].offlineYes : 0, 
                          name: '已成功' , 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                        { 
                          percent: this.dateList[index] && this.dateList[index].offlineBlankNum ? this.dateList[index].offlineBlankNum : 0, 
                          isCopyNane: 2,
                          value: this.chartData[index] && this.chartData[index].offlineNo ? this.chartData[index].offlineNo : 0, 
                          name: '未成功', 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                        { 
                          percent: this.dateList[index] && this.dateList[index].offlineUnknownNum ? this.dateList[index].offlineUnknownNum : 0, 
                          isCopyNane: 2,
                          value: this.chartData[index] && this.chartData[index].offlineUnknown ? this.chartData[index].offlineUnknown : 0, 
                          name: '未知', 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                    ],
                    label: {
                      formatter: function (params) {
                        return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                      },
                    }
                }],
                color: ['#4472c4', '#3dc6c1', '#f6c846']
            });

            // 规划饼图
            let planPie = echarts.init(document.getElementById(`plan-pie-${index}`));
            planPie.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                    },
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: 0,
                    data: ['已成功', '未成功', '未知'],
                    left: 'left',
                    icon: 'circle', // 让图例变成圆点
                    selectedMode: false 
                },
                series: [{
                    customSeriesInfo: {
                      startTime: this.chartData[index].startDate,
                      endTime: this.chartData[index].endDate,
                    },
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '60%'],
                    data: [
                        { 
                          percent: this.dateList[index] && this.dateList[index].projectSuccessNum ? this.dateList[index].projectSuccessNum : 0, 
                          isCopyNane: 1, 
                          value: this.chartData[index] && this.chartData[index].planYes ? this.chartData[index].planYes : 0, 
                          name: '已成功', 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                        { 
                          percent: this.dateList[index] && this.dateList[index].projectBlankNum ? this.dateList[index].projectBlankNum : 0, 
                          isCopyNane: 1, 
                          value: this.chartData[index] && this.chartData[index].planNo ? this.chartData[index].planNo : 0, 
                          name: '未成功', 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                        { 
                          percent: this.dateList[index] && this.dateList[index].projectUnknownNum ? this.dateList[index].projectUnknownNum : 0, 
                          isCopyNane: 1, 
                          value: this.chartData[index] && this.chartData[index].planUnknown ? this.chartData[index].planUnknown : 0, 
                          name: '未知', 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                    ],
                    label: {
                      formatter: function (params) {
                          return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                      },
                    }
                }],
                color: ['#4472c4', '#3dc6c1', '#f6c846']
            });

            // 纯补课饼图
            let makeupPie = echarts.init(document.getElementById(`makeup-pie-${index}`));
            makeupPie.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                    },
                },
                legend: {
                    orient: 'horizontal',
                    top: 0,
                    data: ['已成功', '未成功', '未知'],
                    left: 'left',
                    icon: 'circle', // 让图例变成圆点
                    selectedMode: false 
                },
                series: [{
                    customSeriesInfo: {
                      startTime: this.chartData[index].startDate,
                      endTime: this.chartData[index].endDate,
                    },
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '60%'],
                    data: [
                        { 
                          percent: this.dateList[index] && this.dateList[index].cramSuccessNum ? this.dateList[index].cramSuccessNum : 0, 
                          isCopyNane: 3, 
                          value: this.chartData[index] && this.chartData[index].makeupYes ? this.chartData[index].makeupYes : 0, 
                          name: '已成功', 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate ? this.dateList[index].startDate : '',  endTime: this.dateList[index].endDate ? this.dateList[index].endDate : '' } 
                        },
                        { 
                          percent: this.dateList[index] && this.dateList[index].cramBlankNum ? this.dateList[index].cramBlankNum : 0, 
                          isCopyNane: 3, 
                          value: this.chartData[index] && this.chartData[index].makeupNo ? this.chartData[index].makeupNo : 0, 
                          name: '未成功' , 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate,  endTime: this.dateList[index].endDate }
                        },
                        { 
                          percent: this.dateList[index] && this.dateList[index].cramUnknownNum ? this.dateList[index].cramUnknownNum : 0, 
                          isCopyNane: 3, 
                          value: this.chartData[index] && this.chartData[index].makeupUnknown ? this.chartData[index].makeupUnknown : 0, 
                          name: '未知' , 
                          customSeriesInfo: {  startTime: this.dateList[index].startDate,  endTime: this.dateList[index].endDate }
                        },
                    ],
                    label: {
                        formatter: function (params) {
                            return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                        },
                    }
                }],
                color: ['#4472c4', '#3dc6c1', '#f6c846']
            });


            // params 包含点击的数据项信息
           chartInstance.on('click', params => {

               console.info('左侧图表',params);
               params.classStateType = 0
               params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
               params.isEntirety = 1
               params.isType = 1
               this.params_ZUJIAN = params;
               this.showPopUpNotification = true;
           });

            // 线下饼图
           offlinePie.on('click', params => {
              console.info('右侧图表 --》》 1',params);
              params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
              params.isEntirety = 0
              params.isType = 1
              this.params_ZUJIAN = params;
              params.classStateType = params.data.isCopyNane
              
              this.showPopUpNotification = true;
           });

            // 规划饼图
           planPie.on('click', params => {
                console.info('右侧图表 --》》 2',params);
                params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
                params.isEntirety = 0
                params.isType = 1
                params.classStateType = params.data.isCopyNane

                this.params_ZUJIAN = params;
                this.showPopUpNotification = true;
           });

            // 纯补课饼图
           makeupPie.on('click', params => {
               console.info('右侧图表 --》》 3',params);
               params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
               params.isEntirety = 0
               params.isType = 1
               params.classStateType = params.data.isCopyNane

               this.params_ZUJIAN = params;
               this.showPopUpNotification = true;
           });  




            window.addEventListener('resize', () => {
                chartInstance.resize();
                offlinePie.resize();
                planPie.resize();
                makeupPie.resize();
            })

        })

        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

      })

    },


    getMonthRange(dateString) {
      if (dateString) {
        const parts = dateString.split('-');
        if (parts.length >= 2) {
            return parseInt(parts[1], 10); 
        } else {
            throw new Error('Invalid date format');
        }
      } else {
        return '';
      }
     
    },

    // 获取年份
    getYearRange(dateString) {
      if (dateString) {
        const year = dateString.substring(0, 4);
        return year;
      }else {
        return '';
      }
    },

    getChartOption(itmeIndex) {

      // let isTyleText = '月' 
      let isTyleText =  this.calculationMethod === 1 ? '日' : '月'
     
      return {
        title: {
          text: isTyleText === '月' ? this.getYearRange(this.dateList[itmeIndex].startDate) + '年' + '' + this.getMonthRange(this.dateList[itmeIndex].startDate)  + '月' + '首次课成功率' : isTyleText === '日' ? '首次课成功率' : '',
          subtext:  isTyleText === '月' ? '' : this.dateList[itmeIndex].startDate +' ~ ' + this.dateList[itmeIndex].endDate,
          left: 'center',
          top: '-5', 
          minAngle: 5,
          textStyle: { 
            fontSize: 14, 
            color: '#333',
            verticalAlign: 'top'  
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
             return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
          }
        },
        legend: {
           orient: 'horizontal',
           left: 'left',
           top: 15,
           data: ['已成功', '未成功', '未知'],
           icon: 'circle', // 让图例变成圆点
           selectedMode: false 
        },
        series: [
          { 
            minAngle: 5,
            name: '课消渠道',
            type: 'pie',
            radius: '60%',
            center: ['50%', '70%'], // 这里第二个参数越大越往下
            data: [
                {
                   percent: this.dateList[itmeIndex] && this.dateList[itmeIndex].entiretySuccessNum ? this.dateList[itmeIndex].entiretySuccessNum : 0, 
                   value: this.chartData[itmeIndex] && this.chartData[itmeIndex].channelMakeNumber ? this.chartData[itmeIndex].channelMakeNumber : 0, 
                   name: '已成功', customSeriesInfo: {  startTime: this.dateList[itmeIndex].startDate ? this.dateList[itmeIndex].startDate : '',  endTime: this.dateList[itmeIndex].endDate  ? this.dateList[itmeIndex].endDate : ''} 
                },
                { 
                   percent: this.dateList[itmeIndex] && this.dateList[itmeIndex].entiretyBlankNum ? this.dateList[itmeIndex].entiretyBlankNum : 0, 
                   value: this.chartData[itmeIndex] && this.chartData[itmeIndex].channelOfflineNumber ? this.chartData[itmeIndex].channelOfflineNumber : 0, 
                   name: '未成功', customSeriesInfo: {  startTime: this.dateList[itmeIndex].startDate ? this.dateList[itmeIndex].startDate : '',  endTime: this.dateList[itmeIndex].endDate ? this.dateList[itmeIndex].endDate : '' } 
                },
                {
                   percent: this.dateList[itmeIndex] && this.dateList[itmeIndex].entiretyUnknownNum ? this.dateList[itmeIndex].entiretyUnknownNum : 0, 
                   value: this.chartData[itmeIndex] && this.chartData[itmeIndex].channelProjectNumber ? this.chartData[itmeIndex].channelProjectNumber : 0, 
                   name: '未知' , customSeriesInfo: {  startTime: this.dateList[itmeIndex].startDate ? this.dateList[itmeIndex].startDate : '',  endTime: this.dateList[itmeIndex].endDate ? this.dateList[itmeIndex].endDate : '' }
                }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: function (params) {
                return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
              }
            },
            itemStyle: {
              color: function(params) {
                let colorList = ['#4472c4', '#3dc6c1', '#f6c846'] 
                return colorList[params.dataIndex];
              }
            },
          }
        ]
      }
    },

    handleGetDateList(){

      let data = {}

      if(this.timeMode === 1){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          yearDate: this.selectedYear, 
          weekDate: this.selectedWeekNumber,
        }
      }

      if(this.timeMode === 2){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          yearDate: this.selectedYears,
          monthDate: this.selectedMonthFormatted
        }
      }

      if(this.timeMode === 3){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          yearDate: this.selectyear,
        }
      }

      
      if(this.timeMode === 4){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          startTime: this.dateTime.length > 0 ? this.dateTime[0] : '',
          endTime: this.dateTime.length > 0 ? this.dateTime[1] : '',
        }
      }


      axios.post(`${apiBaseUrl}/firstRecordDiagram/queryAllFirstDiagramProportion`, data ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code === 200){
            if(res.data.code === 200){
              
              let arr = []

              res.data.data.map((item) => {
                  arr.push({
                    channelOfflineNumber: Number(item.entiretyBlankPercentageNum),
                    channelMakeNumber: Number(item.entiretySuccessPercentageNum),
                    channelProjectNumber: Number(item.entiretyUnknownPercentageNum),
                    entiretyBlankNum:Number(item.entiretyUnknownPercentageNum),
                    entiretySuccessNum:Number(item.entiretyUnknownPercentageNum),
                    entiretyUnknownNum:Number(item.entiretyUnknownPercentageNum),


                    offlineNo: Number(item.offlineBlankPercentageNum),
                    offlineYes: Number(item.offlineSuccessPercentageNum),
                    offlineUnknown: Number(item.offlineUnknownPercentageNum),
                    offlineBlankNum: Number(item.offlineBlankNum),
                    offlineSuccessNum : Number(item.offlineSuccessNum),
                    offlineUnknownNum: Number(item.offlineUnknownNum),


                    planYes: Number(item.projectSuccessPercentageNum),
                    planNo: Number(item.projectBlankPercentageNum),
                    planUnknown: Number(item.projectUnknownPercentageNum),
                    projectBlankNum: Number(item.projectBlankNum),
                    projectSuccessNum: Number(item.projectSuccessNum),
                    projectUnknownNum: Number(item.projectUnknownNum),



                    makeupNo: Number(item.cramBlankPercentageNum),
                    makeupYes: Number(item.cramSuccessPercentageNum),
                    makeupUnknown: Number(item.cramUnknownPercentageNum),
                    cramBlankNum: Number(item.cramBlankNum),
                    cramSuccessNum: Number(item.cramSuccessNum),
                    cramUnknownNum: Number(item.cramUnknownNum),

                  })
              })
              
              this.dateList = res.data.data
              this.chartData = arr.length > 0 ? arr : []
              this.$nextTick(() => {
                  this.initCharts()
              })
            }else{
              this.dateList = []
              this.chartData = []
              this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
            }
         }else{
            this.dateList = []
            this.chartData = []
            this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
         }
      })

    },


    handleDownload(){

      loadingUtils.startLoading();

      let data = {}

      if(this.timeMode === 1){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          yearDate: this.selectedYear, 
          weekDate: this.selectedWeekNumber,
        }
      }

      if(this.timeMode === 2){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          yearDate: this.selectedYears,
          monthDate: this.selectedMonthFormatted
        }
      }

      if(this.timeMode === 3){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          yearDate: this.selectyear,
        }
      }

      
      if(this.timeMode === 4){
        data = {
          calculateWay: this.calculationMethod,
          dateType:this.timeMode,
          startTime: this.dateTime.length > 0 ? this.dateTime[0] : '',
          endTime: this.dateTime.length > 0 ? this.dateTime[1] : '',
        }
      }

      let url = this.type === '首次课图表' ? '/firstRecordDiagram/exportAllFirstDiagram' :
                  this.type === '新增率图表' ? '/newCourseDiagram/queryNumCourseDiagram' :
                    this.type === '到课率图表' ? '/scheduleComplete/exportStatistics' :
                      this.type === '取消率图表' ? '/classSales/exportStatistics' :
                        this.type === '流失率图表' ? '/classSales/exportStatistics' :
                          this.type === '续报率图表' ? '/classSales/exportStatistics' : '/classSales/exportStatistics'

      let xlsxName = this.type === '首次课图表' ? '首次课成功率' :
                        this.type === '新增率图表' ? '新增率图率' :
                          this.type === '到课率图表' ? '到课率图率' :
                            this.type === '取消率图表' ? '取消率图率' :
                              this.type === '流失率图表' ? '流失率图率' :
                                this.type === '续报率图表' ? '续报率图率' : ''

      data.exportType = 2

      axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
      
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

        const downloadLink = document.createElement("a")
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download = xlsxName + ".xlsx"
        downloadLink.click()
      }).catch((error) => {
        this.$message.error(error)
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)
      })

    },


    getDefaultDateRange() {
        const today = new Date();
        const year = today.getFullYear();
        let startMonth = today.getMonth() - 6; // 半年前的月份
        let startYear = year;
        
        // 调整年份和月份，确保开始月份正确
        if (startMonth < 0) {
            startMonth += 12;
            startYear -= 1;
        }
        
        // 开始日期总是当月的第一天
        const startDate = new Date(startYear, startMonth, 1);
        
        // 结束日期是当前月份的最后一天
        const endYear = today.getFullYear();
        const endMonth = today.getMonth();
        const endDate = new Date(endYear, endMonth + 1, 0); // 0表示前一个月的最后一天
        
        return [this.formatDate(startDate), this.formatDate(endDate)];
      },
      
      formatDate(date) {
          const y = date.getFullYear();
          let m = date.getMonth() + 1; // Months are zero based
          let d = date.getDate();
          m = m < 10 ? '0' + m : m;
          d = d < 10 ? '0' + d : d;
          return `${y}-${m}-${d}`;
      },


  },


}


</script>




<style  scoped>

.chart-item .el-card__body {
  padding: 0;
}

.chart-item div[id^="chart-"] {
  width: 100%;
  height: 300px;
}


.btns{
   background-color: #428BCA;
   border-color: #428BCA;
   color: #fff;
}


.el-picker-panel >>> .el-date-range-picker >>> .el-popper{
  top: 25% !important;
  left: 20% !important;
}




</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/second.vue